import clsx from 'clsx';

import { TeamIcon, UserIcon } from '~components/icons';
import styles from './Table.module.css';

export type TableCellNameProps = {
  value: string;
  row: { original: { type: 'user' | 'group' } };
};

export const TableCellName = ({ value, row }: TableCellNameProps) => (
  <div className={clsx(styles.cellName)}>
    {row.original.type === 'user' && (
      <span className={styles.cellNameIcon}>
        <UserIcon />
      </span>
    )}
    {row.original.type === 'group' && (
      <span className={styles.cellNameIcon}>
        <TeamIcon />
      </span>
    )}
    <span className={styles.cellNameLabel}>{value}</span>
  </div>
);
